var _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1,7.5C1,7.4,1,7.4,1,7.5l0.7,0c0.1,0,0.3,0.1,0.4,0.2l1.8,1.8l1,1l0.2,0.2l0.5,0.5L6,11.6 c0.3,0.4,0.7,0.6,1.1,0.7l1.1,0.3l-5.6,0.3l-0.1-0.4l0.8-0.1c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0-0.2l0-0.3l-0.4-1l-0.1-0.2l-0.4-1 l-0.4-1c0-0.2-0.2-0.3-0.3-0.3H1.2L1,7.7C1,7.6,1,7.6,1,7.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4,13c0-0.1,0.1-0.2,0.1-0.2c0.1,0,0.2,0,0.3,0c1.4-0.3,5.7-1,15.6-0.7c0.5,0,2,0.2,3.2,0.7 c0.1,0,0.2,0.1,0.3,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.3,0.3,0.4c0,0,0.1,0.1,0.2,0.2c0.1,0,0.1,0.1,0.2,0.1 c0,0.1,0.1,0.1,0.1,0.2c0,0.8-1.1,1.3-2.5,1.6c-1.6,0.3-3.3,0.3-3.3,0.3H9.4c-4.3-0.4-6.3-2-7-2.7C2.4,13.1,2.4,13.1,2.4,13z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M3.9,13.1c0.7,0,1.4,0.1,1.8,0.2c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c-0.4,0.1-1.1,0.2-1.8,0.2 c-0.8,0-1.5-0.1-1.9-0.2c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1C2.4,13.2,3.1,13.1,3.9,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M1.9,8.2H1.1l0,0.1l1.2,4l0,0.1l0.8-0.1c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0-0.2l0-0.3l-0.4-1l-0.1-0.2l-0.4-1 l-0.4-1C2.1,8.3,2,8.3,1.9,8.2L1.9,8.2z M3.3,12.1C3.3,12.1,3.3,12.1,3.3,12.1C3.3,12.1,3.3,12.1,3.3,12.1z M2.1,8.6l0.3,1l0.4,1 l0.1,0.2l0.4,1l0.1,0.3L2.1,8.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M17.1,13.2v0.1c0,0,0,0,0,0.1v0c0,0,0,0,0,0l0,0c0,0,0.1,0.1,0.1,0.1l0,0c0.1,0,0.2-0.1,0.2-0.2v-0.1 c0,0,0-0.1,0-0.1l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0C17.2,13.1,17.1,13.1,17.1,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M16.4,13.2v0.1c0,0,0,0,0,0.1v0c0,0,0,0,0,0l0,0c0,0,0.1,0.1,0.1,0.1l0,0c0.1,0,0.2-0.1,0.2-0.2v-0.1 c0,0,0-0.1,0-0.1l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0C16.4,13.1,16.4,13.1,16.4,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M15.7,13.2v0.1c0,0,0,0,0,0.1v0c0,0,0,0,0,0l0,0c0,0,0.1,0.1,0.1,0.1l0,0c0.1,0,0.2-0.1,0.2-0.2v-0.1 c0,0,0-0.1,0-0.1l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0C15.7,13.1,15.7,13.1,15.7,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M15,13.2v0.1c0,0,0,0,0,0.1v0c0,0,0,0,0,0l0,0c0,0,0.1,0.1,0.1,0.1l0,0c0.1,0,0.2-0.1,0.2-0.2v-0.1 c0,0,0-0.1,0-0.1l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0C15,13.1,14.9,13.1,15,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M14.2,13.2v0.1c0,0,0,0,0,0.1v0c0,0,0,0,0,0l0,0c0,0,0.1,0.1,0.1,0.1l0,0c0.1,0,0.2-0.1,0.2-0.2v-0.1 c0,0,0-0.1,0-0.1l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0C14.3,13.1,14.2,13.1,14.2,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M13.5,13.2v0.1c0,0,0,0,0,0.1v0c0,0,0,0,0,0l0,0c0,0,0.1,0.1,0.1,0.1l0,0c0.1,0,0.2-0.1,0.2-0.2v-0.1 c0,0,0-0.1,0-0.1l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0C13.6,13.1,13.5,13.1,13.5,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M12.8,13.2v0.1c0,0,0,0,0,0.1v0c0,0,0,0,0,0l0,0c0,0,0.1,0.1,0.1,0.1l0,0c0.1,0,0.2-0.1,0.2-0.2v-0.1 c0,0,0-0.1,0-0.1l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0C12.8,13.1,12.7,13.1,12.8,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M12.1,13.2v0.1c0,0,0,0,0,0.1v0c0,0,0,0,0,0l0,0c0,0,0.1,0.1,0.1,0.1l0,0c0.1,0,0.2-0.1,0.2-0.2v-0.1 c0,0,0-0.1,0-0.1l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0C12.1,13.1,12,13.1,12.1,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M11.4,13.2v0.1c0,0,0,0,0,0.1v0c0,0,0,0,0,0l0,0c0,0,0.1,0.1,0.1,0.1l0,0c0.1,0,0.2-0.1,0.2-0.2v-0.1 c0,0,0-0.1,0-0.1l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0C11.4,13.1,11.3,13.1,11.4,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M10.6,13.5L10.6,13.5C10.6,13.5,10.6,13.5,10.6,13.5L10.6,13.5c0,0.1,0.1,0.2,0.1,0.2l0,0 c0.1,0,0.2-0.1,0.2-0.2v-0.1c0,0,0-0.1,0-0.1l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0h0l0,0c-0.1,0-0.2,0.1-0.2,0.2L10.6,13.5 C10.6,13.5,10.6,13.5,10.6,13.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M9.4,15.4c2.4,0.4,4.8,0.4,7.3,0c-0.9-0.7-4.8-1.1-7.9-1.5H7.4L9.4,15.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "7.4,13.9 8.7,13.9 7.9,12.7 7.4,12.7  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2,15.4C8.2,15.4,8.2,15.4,8.2,15.4c0.7-0.2,1.8-0.4,2.5-0.4c0.5,0,0.8,0,1,0.1c0,0,0.1,0,0.1,0.1 c0,0,0.1,0,0.1,0.1v0.9c0,0,0,0-0.1,0.1c0,0-0.1,0-0.1,0.1c-0.2,0.1-0.5,0.1-1,0.1c-0.7,0-1.7-0.1-2.4-0.3c0,0,0,0-0.1,0h0 L8.2,15.4L8.2,15.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M21.6,13.1h0.6c0.1,0.1,0.2,0.3,0.3,0.4c0,0,0.1,0.1,0.2,0.2h-1.1c-0.1,0-0.2-0.1-0.2-0.2v-0.1 C21.4,13.2,21.5,13.1,21.6,13.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.975919b1be050fbfd9ad0a35ff93128e.svg";
export { ForwardRef as ReactComponent };